import React from "react";
import { Typography, Box } from "@mui/material";

export default function BackButton() {
  return (
    <Box mb={2}>
      <Typography
        component="a"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          window.history.back();
        }}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline"
          },
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        }}
      >
        ← Back
      </Typography>
    </Box>
  );
}
